export default __webpack_public_path__ + "static/media/sampleForm.862809b4.csv";